export default __webpack_public_path__ + "static/media/pl_sun.f472017b.jpg";